import type { BloodTestPackage, CartProduct } from "../models";

export const checkIfAnyUpsellProductInCart = (
  upsellBloodTestPackagesBasedOnStandardProduct: (BloodTestPackage | undefined)[] | undefined,
  products: CartProduct[],
): boolean => {
  return (
    upsellBloodTestPackagesBasedOnStandardProduct?.some(
      (btp) => btp && products.some((product) => product.uuid === btp.uuid),
    ) ?? false
  );
};
